import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Grid } from "@mui/material";
import styled from "styled-components";

function createData(moduleName, description, output, expectedUser) {
  return { moduleName, description, output, expectedUser };
}

export const Data = styled.div`
color: ${({ theme }) => {
  return theme.colors.title;
}};
font: normal normal normal 14px/19px Open Sans;
`;

const Eng_Sales = "Eng, Sales";

const rows = [
  createData(
    "NaPA Data Lookup",
    "NaPA data for network and market insights",
    "CSV",
    Eng_Sales
  ),
  createData(
    "Colo Study",
    "EDOTCO site distance matrix & colo opportunity with other mobile operators",
    "XLXS",
    "Eng, Sales, M&A"
  ),
  createData(
    "4G RSRP Plots",
    "4G coverage (signal,strength,dBm) heat map",
    "KML",
    Eng_Sales
  ),
  createData(
    "4G DL Speed Plots",
    "4G user experience (download speed, Mbps) heat map",
    "KML",
    Eng_Sales
  ),
  createData(
    "Intersite Distance Tool",
    "Measure distance between 2 points",
    "CSV",
    "Eng"
  ),
  createData(
    "NaPA Study Master Site List",
    "The whole list of proposed nominal and colo sites",
    "CSV",
    "Eng"
  ),
  createData(
    "NaPA Study Master Geohash Plots ",
    "Nationwide geohash plots with NaPA data",
    "CSV & SHP",
    "Eng"
  ),
  createData(
    "Ookla Data Stats",
    "Count of geohash for all signal strength and download speed levels",
    "CSV",
    "Eng"
  ),
];

export default function HomeTable() {
  return (
    <Grid
      container
      item
      style={{
        justifyContent: "space-between",
        textAlign: "left",
        font: "normal normal normal 16px/22px Open Sans",
        letterSpacing: "0px",
        color: "#5e5e5e",
        opacity: "1",
        padding: "10px",
        width: "84%",
        position: "absolute",
        top: "570px",
        left: "100px",
      }}
    >
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Module Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Output</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.moduleName}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <Data>{row.moduleName}</Data>
                </TableCell>
                <TableCell>
                  <Data>{row.description}</Data>
                </TableCell>
                <TableCell>
                  <Data>{row.output}</Data>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
}
